<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <LeituraAdmHotel />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import LeituraAdmHotel from "../Components/Leituras/LeituraAdmHotel.vue";
export default {
  name: "ReadAdmHotel",
  components: {
    LeituraAdmHotel,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>
